module.exports = __webpack_public_path__ + "img/HS7-Full-French-Lace-Hair-System-for-Men-4-300x300.378831b6.jpg";